import { render, staticRenderFns } from "./homeWorkNew.vue?vue&type=template&id=00453de5&"
import script from "./homeWorkNew.vue?vue&type=script&lang=js&"
export * from "./homeWorkNew.vue?vue&type=script&lang=js&"
import style0 from "./homeWorkNew.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./homeWorkNew.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports